import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { DocumentStatusesService } from '../document-statuses.service';
import { DocumentStatusesAddPayload, DocumentStatusesEditPayload } from '../document-statuses.interface';

@Component({
    selector: 'app-edit-document-statuses',
    templateUrl: './edit-document-statuses.component.html',
    styleUrls: ['./edit-document-statuses.component.scss']
})
export class EditDocumentStatusesComponent {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        slug: new FormControl(this.data.slug, [Validators.required]),
        description: new FormControl(this.data.description, []),
        color: new FormControl(this.data.color, [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditDocumentStatusesComponent>,
        private requestService: DocumentStatusesService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() { }

    submitForm() {
        this.isLoading = true;

        const { name, slug, description, color } = this.form
            .value as DocumentStatusesAddPayload;
        const payload: DocumentStatusesEditPayload = {
            id: this.data.id,
            name,
            slug,
            description,
            color
        };

        this.requestService
            .updateEntry(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
